import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=45a87a02&"
import script from "./Website.vue?vue&type=script&lang=js&"
export * from "./Website.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a87a02')) {
      api.createRecord('45a87a02', component.options)
    } else {
      api.reload('45a87a02', component.options)
    }
    module.hot.accept("./Website.vue?vue&type=template&id=45a87a02&", function () {
      api.rerender('45a87a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Website.vue"
export default component.exports